import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useTranslation } from "react-i18next";

import "./style.scss";
import { BUSINESS_LINE_COLORS } from "helpers/utils";

function PromoCode({
  visible = false,
  setVisible = () => { },
  promocode = "",
  setPromocode = () => { },
  handleApplyPromo = () => { },
  promoCodeApplied = false,
  handleRemovePromo = () => { },
  businessColor = BUSINESS_LINE_COLORS.DEFAULT
}) {
  const { t } = useTranslation();

  const [applyMsg, setApplyMsg] = useState(false)

  useEffect(() => {
    if (promoCodeApplied) {
      setApplyMsg(true)
      setTimeout(() => {
        setApplyMsg(false)
      }, 1000)
    }
  }, [promoCodeApplied])

  return (
    <Dialog
      header=""
      visible={visible}
      onHide={() => setVisible(false)}
      className="common_promocode"
      position={window.innerWidth <= 600 ? 'bottom' : 'center'}
    >
      <div className="common_promocode_wrap">
        <div className="cpw_cnt">
          <h1>{t('PAYMENT.PROMOCODE')}</h1>
          <InputText
            value={promocode}
            onChange={(e) => setPromocode(e.target.value)}
            placeholder={t('PAYMENT.YOURPROMO')}
          // disabled={promoCodeApplied}
          />
          {applyMsg && <p>{t("PAYMENT.APPLIED")}</p>}
          <Button
            label={t("PAYMENT.APPLY")}
            // label={promoCodeApplied ? t("PAYMENT.APPLIED") : t("PAYMENT.APPLY")}
            icon="pi pi-plus-circle mx-2"
            onClick={handleApplyPromo}
          // disabled={promoCodeApplied}
            style={{background: businessColor}}
          />
          {promoCodeApplied && <div className="cpw_cnt_remove" onClick={handleRemovePromo}>
            <h5>{t("PAYMENT.REMOVE_code")}</h5>
          </div>}
        </div>
      </div>
    </Dialog>
  );
}

export default PromoCode;
